import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 26",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 26,
		height: 26,
		rx: 6,
		fill: "#C4C4C4"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.6172 6.75781V10.3418H18.2656C18.0573 9.51497 17.8262 8.92253 17.5723 8.56445C17.3184 8.19987 16.9701 7.91016 16.5273 7.69531C16.2799 7.57812 15.847 7.51953 15.2285 7.51953H14.2422V17.7344C14.2422 18.4115 14.278 18.8346 14.3496 19.0039C14.4277 19.1732 14.5742 19.3229 14.7891 19.4531C15.0104 19.5768 15.3099 19.6387 15.6875 19.6387H16.127V20H9.19336V19.6387H9.63281C10.0169 19.6387 10.3262 19.5703 10.5605 19.4336C10.7298 19.3424 10.8633 19.1862 10.9609 18.9648C11.0326 18.8086 11.0684 18.3984 11.0684 17.7344V7.51953H10.1113C9.2194 7.51953 8.57161 7.70833 8.16797 8.08594C7.60156 8.61328 7.24349 9.36523 7.09375 10.3418H6.72266V6.75781H18.6172Z",
		fill: "white"
	})]
});
export default SvgText;
